/**
 * DrawdownChart — SVG drawdown-from-peak curve.
 *
 * Props:
 *   data   [{date, drawdown_pct}]   drawdown_pct <= 0
 *   stats  {n_episodes, max_drawdown_duration, avg_drawdown_duration}
 *   height number  SVG height (default 160)
 */
import {
  ComposedChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function DrawdownChart({ data = [], stats = {}, height = 160 }) {
  if (!data.length) return null;

  const chartdata = data.map((i)=> {
      return {
          "date": i.date,
          "Drawdown": i.drawdown_pct
      }
  })
  const equityColour = "hsl(var(--loss))"

  return (
    <div className="flex flex-col gap-3">
      {/* Stats row */}
      {(stats.n_episodes > 0) && (
        <div className="flex flex-wrap gap-4 text-xs">
          <span className="flex flex-col">
            <em className="text-[10px] uppercase font-semibold text-muted-foreground not-italic mb-0.5">Episodes</em>
            <strong className="text-foreground">{stats.n_episodes}</strong>
          </span>
          <span className="flex flex-col">
            <em className="text-[10px] uppercase font-semibold text-muted-foreground not-italic mb-0.5">Longest</em>
            <strong className="text-loss">{stats.max_drawdown_duration} days</strong>
          </span>
          <span className="flex flex-col">
            <em className="text-[10px] uppercase font-semibold text-muted-foreground not-italic mb-0.5">Avg Duration</em>
            <strong className="text-foreground">{stats.avg_drawdown_duration} days</strong>
          </span>
        </div>
      )}
      <div className="h-40 w-full text-xs"> 
        <ResponsiveContainer>
          <ComposedChart
          data={chartdata}
          margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
          >
            <CartesianGrid 
              strokeWidth={1} strokeOpacity={0.5}
              strokeDasharray="3 3" vertical={false}/>
                                
            <defs>
                <linearGradient id="chartGradientDrawdown" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={equityColour} stopOpacity={0.6} />
                <stop offset="95%" stopColor={equityColour} stopOpacity={0.0} />
                </linearGradient>
            </defs>

            <XAxis 
              dataKey="date"
              axisLine={false} 
              dy={10}
              tick={{fill: 'hsl(var(--foreground))'}}
              minTickGap={10}
            />
            
            <YAxis
              axisLine={false} 
              tickLine={false}
              domain={['dataMin', 'auto']}
              tick={{fill: 'hsl(var(--foreground))'}}
            />
            
            <Tooltip 
              labelStyle={{ color: 'hsl(var(--foreground))' }}
              contentStyle={{background: 'hsl(var(--background))', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
            />

            {/* The Area Chart (Revenue) */}
            <Area
                type="monotone"
                dataKey="Drawdown"
                fill="url(#chartGradientDrawdown)"
                stroke={equityColour}
                fillOpacity={0.3}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
